import type { BadgeTono } from "@/components";
import type { CanalAviso, EstadoAviso, TipoAviso } from "./api";

export const rutaPreferencias = (fid: number) => `/api/fideicomisos/${fid}/avisos/preferencias`;

export function rutaAvisos(fid: number, estado: EstadoAviso | "todos", canal: CanalAviso | "todos" = "todos"): string {
  const params = new URLSearchParams();
  if (estado !== "todos") params.set("estado", estado);
  if (canal !== "todos") params.set("canal", canal);
  const q = params.toString();
  return `/api/fideicomisos/${fid}/avisos${q ? `?${q}` : ""}`;
}

export const ETIQUETA_CANAL_AVISO: Record<CanalAviso, string> = { mail: "Mail", push: "Celular" };

export const OPCIONES_FILTRO_CANAL: { valor: string; etiqueta: string }[] = [
  { valor: "todos", etiqueta: "Todos" },
  { valor: "mail", etiqueta: "Mail" },
  { valor: "push", etiqueta: "Celular" },
];

export const ETIQUETA_TIPO_AVISO: Record<TipoAviso, string> = {
  llamado_nuevo: "Previsión nueva",
  llamado_recordatorio: "Recordatorio de previsión",
  novedad: "Novedad de obra",
  respaldo_fallido: "Backup fallido",
  respaldo_ausente: "Backup ausente",
};

export const ETIQUETA_ESTADO_AVISO: Record<EstadoAviso, string> = {
  pendiente: "Pendiente",
  enviado: "Enviado",
  fallido: "Falló",
  descartado: "Descartado",
};

export const TONO_ESTADO_AVISO: Record<EstadoAviso, BadgeTono> = {
  pendiente: "alerta",
  enviado: "exito",
  fallido: "peligro",
  descartado: "neutro",
};

export const OPCIONES_FILTRO_ESTADO: { valor: string; etiqueta: string }[] = [
  { valor: "todos", etiqueta: "Todos" },
  ...(Object.keys(ETIQUETA_ESTADO_AVISO) as EstadoAviso[]).map((valor) => ({ valor, etiqueta: ETIQUETA_ESTADO_AVISO[valor] })),
];
